import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';
import { UserService } from './core/user.service';

@Injectable()

export class GroupOfPoliceService {
	public url: string;
	public identity: any;
	public token: any;
	public entidad: any;
	private entity: any

	private _userService: UserService = inject(UserService)

	constructor(
		private _http: HttpClient,
	) {
		this.url = Global.url_seguros;
		this.entity = this._userService.sharingEntity()
	}
	getAll(year?: number | null): Observable<any> {
		const params = year ? { params: { year: year.toString() } } : {}
		return this._http.get(this.url + 'groups', params)
	}

	getByPolicy(policy: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		var resultado = this._http.get(this.url + 'groups/' + policy , {headers: headers})
		return resultado;

	}

	getTypes(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'group-policies/types', {headers: headers})
	}

	createType(params: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'group-policies/types', {params}, {headers: headers})
	}

	save(group: any): Observable<any> {
		let params = group;
		//definir las cabeceras
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		//Hacer peticion ajax
		var resultado = this._http.post(this.url + 'group-policies', params, {headers: headers})
		return resultado;
	}
	update(group: any): Observable<any> {
		let params = group

		let headers = new HttpHeaders().set('Content-Type','application/json; charset=utf-8')

		var resultado = this._http.patch(this.url + 'group-policies/' + params._id, params, {headers: headers})
		return resultado;
	}





}
